import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Plus, Building2, Users, Target, Warehouse, Landmark, ListChecks, CalendarPlus } from 'lucide-react'

const ITEMS = [
  { label: 'Account', icon: Building2, to: '/accounts' },
  { label: 'Contact', icon: Users, to: '/contacts' },
  { label: 'Opportunity', icon: Target, to: '/opportunities' },
  { label: 'Property', icon: Warehouse, to: '/properties' },
  { label: 'Fund', icon: Landmark, to: '/funds' },
  { label: 'Task / Action Item', icon: ListChecks, to: '/tasks?new=1' },
  { label: 'Meeting', icon: CalendarPlus, to: '/calendar' },
]

export function QuickAdd() {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  const navigate = useNavigate()
  useEffect(() => {
    const onClick = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false) }
    window.addEventListener('mousedown', onClick)
    return () => window.removeEventListener('mousedown', onClick)
  }, [])
  return (
    <div className="quickadd" ref={ref}>
      <button className="quickadd-btn" aria-label="Create" onClick={() => setOpen((o) => !o)}>
        <Plus size={18} />
      </button>
      {open && (
        <div className="quickadd-menu">
          <div className="quickadd-head label">Create</div>
          {ITEMS.map((it) => {
            const Icon = it.icon
            return (
              <button key={it.label} className="quickadd-item" onClick={() => { setOpen(false); navigate(it.to) }}>
                <Icon size={15} />
                <span>{it.label}</span>
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}
